module.exports = __webpack_public_path__ + "static/logo-9839e5c45a9edbd9c5f80a893ff01b6c.jpg";